import { motion } from 'framer-motion'
import { Quote } from 'lucide-react'

const Testimonials = () => {
  const testimonials = [
    {
      quote: "Saved us weeks of screening time. We hired faster with more confidence.",
      author: "Mira, Founder @ Seedly"
    },
    {
      quote: "Pay-as-you-go is perfect for us. No lock-ins, just results.",
      author: "Raghav, CTO @ SprintIQ"
    },
    {
      quote: "Interview summaries are spot-on. Our team focuses on final rounds only.",
      author: "Ayesha, Ops @ CrewLab"
    }
  ]

  const logos = ["Startup India", "YCP Accelerator", "NASSCOM CoE"]

  return (
    <section className="section bg-white">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Loved by early-stage teams
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              className="bg-white p-6 rounded-2xl border border-gray-100 relative hover:shadow-lg transition-all duration-300"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.15, duration: 0.6 }}
              viewport={{ once: true }}
            >
              <Quote className="w-8 h-8 text-primary-200 mb-4" />
              
              <p className="text-lg text-gray-700 italic mb-4 leading-relaxed">
                "{testimonial.quote}"
              </p>
              
              <footer className="text-sm font-medium text-gray-500">
                {testimonial.author}
              </footer>
            </motion.div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-sm text-gray-500 mb-4">Incubators and accelerators</p>
          <div className="flex flex-wrap justify-center gap-4">
            {logos.map((logo, index) => (
              <span
                key={index}
                className="px-4 py-2 bg-gray-50 text-gray-600 rounded-full text-sm border border-gray-100"
              >
                {logo}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Testimonials
